import React, { useEffect, useState } from 'react'
import BaseProductManagementColumnModel from './base-product-management-column-model'
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../services/api/api-urls'
import { getSelectOptions } from '../../../components/common/common-form/common-form-select'
import BaseProductManagementDialog from './base-product-management-dialog'
import { getRandomKey } from '../../../services/lib/utils/helpers'
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service'
import { ApiRequest } from '../../../services/api/api'
import { getUserId } from '../../../services/lib/utils/auth.utils'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const BaseProduct: any = () => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false)
  const [bpDialogVisible, setBpDialogVisible] = useState(false)
  const [bpDialogMode, setBpDialogMode] = useState<'add' | 'edit'>('add')
  const [selectedBaseProduct, setSelectedBaseProduct] = useState<any>(null)

  useDocumentTitle();
  // useEffect(() => {
  //   document.title = "Base Product";
  //  }, [])
  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.BaseProduct,
    title: 'Base Product',
    column: BaseProductManagementColumnModel(),
  }

  const handleOpenBaseProductDialog = (mode: 'add' | 'edit', rowData?: any) => {
    setBpDialogMode(mode)
    setSelectedBaseProduct(rowData || null)
    setBpDialogVisible(true)
  }

  const handleBaseProductDialogClose = (saved?: boolean, response?: any) => {
    setBpDialogVisible(false)
    if (saved) {
      setTriggerResetData(getRandomKey())
    }
  }

  return (
    <>
      <CommonTablePage
        {...commonTablePageProps}
        mappingRenderData={async (data: any) => {
          const rawMaterialData = await getSelectOptions(urlKey.RawMaterial)
          const packagingTypeData = await getSelectOptions(urlKey.PackagingType)
          console.log('packagingTypeData for mapping:', packagingTypeData)

          return data.map((row: any) => ({
            ...row,
            rawMaterial2: rawMaterialData.filter((item: any) => item.rawMaterialId === row.rawMaterialId2)[0],
            packagingType: packagingTypeData.filter((item: any) => item.packagingTypeId === row.packagingTypeId)[0]
          }))
        }}
        mappingUpdateData={ async (dataDetail: any) => {
          console.log('mappingUpdateData received data:', dataDetail)
          console.log('packagingTypeId value:', dataDetail.packagingTypeId)

          // Pack Type 必填验证
          if (!dataDetail.packagingTypeId || dataDetail.packagingTypeId === null || dataDetail.packagingTypeId === undefined) {
            await SweetAlertService.errorMessage('Pack Type is required!')
            return null // 阻止保存
          }

          if (dataDetail.productCode && dataDetail.productCode.length > 22) {
            const result = await SweetAlertService.warningConfirm(
              `Product Code exceeds 22 characters (${dataDetail.productCode.length} chars). Do you want to continue saving?`,
              'Warning'
            );
            if (result.dismissed) {
              return null; // 用户取消，中止保存
            }
          }
          const result = {
            ...dataDetail,
            manufactured: parseInt(dataDetail.manufactured, 10),
            visible: parseInt(dataDetail.visible, 10),
          }

          console.log('Final result for API:', {
            packagingTypeId: result.packagingTypeId,
            fullResult: result
          })

          // Convert carton dimensions to number or null
          if (dataDetail.cartonLength !== undefined) {
            result.cartonLength = (dataDetail.cartonLength != null && dataDetail.cartonLength !== '' && !isNaN(dataDetail.cartonLength)) ? Number(dataDetail.cartonLength) : null;
          }
          if (dataDetail.cartonWidth !== undefined) {
            result.cartonWidth = (dataDetail.cartonWidth != null && dataDetail.cartonWidth !== '' && !isNaN(dataDetail.cartonWidth)) ? Number(dataDetail.cartonWidth) : null;
          }
          if (dataDetail.cartonHeight !== undefined) {
            result.cartonHeight = (dataDetail.cartonHeight != null && dataDetail.cartonHeight !== '' && !isNaN(dataDetail.cartonHeight)) ? Number(dataDetail.cartonHeight) : null;
          }

          return result;
        } }
        triggerResetData={triggerResetData}
        isNotDeletable={true}
        isNotEditable={true}
        onAddClick={() => handleOpenBaseProductDialog('add')}
        actionButtons={[
          {
            icon: 'edit',
            tooltip: 'Edit',
            isFreeAction: false,
            onClick: (event: any, rowData: any) => {
              handleOpenBaseProductDialog('edit', rowData)
            }
          },
          {
            icon: 'ghost', //Button attr of Ant design (danger, ghost)
            tooltip: 'Delete',
            isFreeAction: false,
            onClick: async (event: any, rowData: any) => {
              const resultInput = await SweetAlertService.deleteConfirm();
              if (resultInput.dismissed) return;
              const [name, reason] = Array.isArray(resultInput.value) ? resultInput.value : [];         
                console.log(rowData)
                ApiRequest({ url: `BaseProduct/DeleteBaseProduct?id=${rowData.baseProductId}&userId=${getUserId()}&userName=${name}&Notes=${reason}`, method: 'delete'})               
                  .then((res: any) => {
                  SweetAlertService.successMessage()
                  setTriggerResetData(getRandomKey())
                })
            }
          }

        ]}
      />
      <BaseProductManagementDialog
        visible={bpDialogVisible}
        mode={bpDialogMode}
        baseProductData={selectedBaseProduct}
        onClose={handleBaseProductDialogClose}
        onDataChanged={() => setTriggerResetData(getRandomKey())}
      />

    </>
  )
}

export default BaseProduct
